import { defineField } from '../fieldBuilder';
import type { RequestFieldDefinition } from '../types';

/** Monitoring fields (legacy step; subsection metrics + optional Summary rows). */
export const MONITORING_MANAGEMENT_FIELDS: readonly RequestFieldDefinition[] = [
  defineField('rack-power', 'monitoringInformation', 0, 'mgmtDescribeMonitoringControlSoftwareNeeds', 'Describe Monitoring & Control Software needs', 'Software needs'),
  defineField('rack-power', 'monitoringInformation', 1, 'mgmtAdditionalRemoteMgmtInfo', 'Additional Monitoring & Management Information', 'Notes'),
];
